// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"styles_infoRow__6kG--","title":"styles_title__5r8_Q","value":"styles_value__h1rWY","autobookInfoFlexP":"styles_autobookInfoFlexP__2cdcr"};